import { useEffect, useState } from "react";
import customerServices from "../../services/CustomerService";
import { Table, Button, Space,Tooltip } from "antd";
import { FilePdfOutlined, CloudDownloadOutlined } from "@ant-design/icons";
import Lodder from "../../components/Lodder";
const CustomerAgreements = () => {
  const [showlodder, setShowlodder] = useState(false);
  const handleOpenPreview = (filePath) => {
     ;
    customerServices
      .DownloadCustomerAgreementByPath(filePath)
      .then((response) => {
        const blob = new Blob([response], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleDownloadFile = (filePath) => {
     ;
    customerServices
      .DownloadCustomerAgreementByPath(filePath)
      .then((response) => {
        const blob = new Blob([response], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = "RegistrationAgreement.pdf";
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [customerAgreements, setcustomerAgreements] = useState([]);
  useEffect(() => {
    setShowlodder(true);
    document.title = "Foundry Law - Agreements";
    customerServices
      .GetCustomerAgreements()
      .then((response) => {
        if (response.status) {
          setcustomerAgreements(response.resultData);
        }
      })
      .finally(() => {
        setShowlodder(false);
      });
  }, []);
  const columns = [
    {
      title: "CREATED",
      dataIndex: "createdDate",
      key: "createdDate",
      sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
      render: (date) => {
        return (
          <>
            {new Date(date).toLocaleDateString("en-US", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </>
        );
      },
    },
    {
      title: "LEGAL TOOL",
      dataIndex: "agreementName",
      key: "agreementName",
      sorter: (a, b) => a.agreementName.localeCompare(b.agreementName),
    },
    {
      title: "BUSINESS NAME",
      dataIndex: "businessName",
      key: "businessName",
      sorter: (a, b) => a.businessName.localeCompare(b.businessName),
    },
    {
      title: "ACTIONS",
      dataIndex: "filePath",
      key: "filePath",
      render: (filePath) => {
        return (
          <Space size="small">
            <Tooltip title="Preview">
            <Button
              type="text"
              icon={<FilePdfOutlined />}
              onClick={() => handleOpenPreview(filePath)}
            />
            </Tooltip>
            <Tooltip title="Download">
            <Button
              type="text"
              icon={<CloudDownloadOutlined />}
              onClick={() => handleDownloadFile(filePath)}
            />

            </Tooltip>
          </Space>
        );
      },
    },
  ];
  return (
    <div className="content-wrapper">
      {/* Content Header (Page header) */}
      <div className="content-header">
        <div className="container-fluid mt-5 pt-3">
          <div className="row mx-lg-3 mx-0 my-3">
            <div className="col-lg-12">
              <div className="card border-0 shadow card-span w-100">
                <div className="card-header property-header py-3">
                  <h5 className="mb-0 property-heading-card">TERMS</h5>
                </div>
                <div className="p-4 mt-2 table-responsive">
                  <Table
                    dataSource={customerAgreements}
                    columns={columns}
                    pagination={{
                      showSizeChanger: true,
                      pageSizeOptions: ["5", "10", "20", "50", "100"],
                      defaultPageSize: 10,
                      total: customerAgreements.length,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      itemRender: (current, type, originalElement) => {
                        if (type === "prev") {
                          return <Button>Previous</Button>;
                        }
                        if (type === "next") {
                          return <Button>Next</Button>;
                        }
                        return originalElement;
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Lodder show={showlodder} />
    </div>
  );
};
export default CustomerAgreements;
